import styled, { css } from 'styled-components'
import { Button } from '@ads/front-ds'

export const ButtonCTA = styled(Button)`
  ${p => css`
    background-color: ${p.theme.colors.primary100};
  `}
`
